import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, Select } from '@mui/material';
import { zoneSelectStyle } from 'common/ZoneSelect/ZoneSelect.style';
import { deviceTypes } from 'globals/global.types';
var DeviceTypeSelect = function (_a) {
    var _b = _a.deviceType, deviceType = _b === void 0 ? '' : _b, _c = _a.onChange, onChange = _c === void 0 ? function (e) { } : _c, _d = _a.hasAllOption, hasAllOption = _d === void 0 ? false : _d, disabled = _a.disabled, serial = _a.serial;
    var classes = zoneSelectStyle({ hasAllOption: hasAllOption }).classes;
    return (_jsxs(Select, { disabled: disabled, displayEmpty: true, value: deviceType || '', onChange: onChange, className: classes.root, inputProps: {
            'data-testid': 'zone-select',
        }, onClick: function (e) {
            e.stopPropagation();
        }, children: [hasAllOption ? (_jsx(MenuItem, { "data-testid": 'allZones', value: '', children: "".concat(serial ? 'All Types' : 'None') })) : (_jsx(MenuItem, { value: '', children: "Select device" })), deviceTypes.map(function (device) { return (_jsx(MenuItem, { value: device.value, children: device.label }, device.value)); })] }));
};
export default DeviceTypeSelect;
